import { useEffect } from "react";
import { Period } from "my-timesheet/types/period";
import useOcButtonGroup from "oc/hooks/use-button-group";

interface UseMyTimesheetPeriodSelectorProps {
  period: Period;
  handlePeriodChange: (period: Period) => void;
}

export const useMyTimesheetPeriodSelector = ({
  period,
  handlePeriodChange,
}: UseMyTimesheetPeriodSelectorProps) => {
  const buttonsDef = ["MY_TIMESHEET_MONTHLY", "MY_TIMESHEET_WEEKLY"];
  const { OcButtonGroup, selectedButton, handleButtonChange } =
    useOcButtonGroup({
      id: "MySheetWorktimeSummaryPeriod",
      buttonsDef,
    });

  useEffect(() => {
    if (period === "month") {
      handleButtonChange(0);
    }
    if (period === "week") {
      handleButtonChange(1);
    }
  }, [period]); // eslint-disable-line

  useEffect(() => {
    if (selectedButton === "MY_TIMESHEET_MONTHLY") {
      handlePeriodChange("month");
    } else {
      handlePeriodChange("week");
    }
  }, [selectedButton]); // eslint-disable-line

  return { OcButtonGroup };
};

export default useMyTimesheetPeriodSelector;
